module.exports = __webpack_public_path__ + "img/li-ronghua.e9bec31f.jpeg";